import { render, staticRenderFns } from "./OrderItemAttachmentNoteCreateModal.vue?vue&type=template&id=0c2e2646"
import script from "./OrderItemAttachmentNoteCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderItemAttachmentNoteCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports